<tui-root>
  @if ({ loading: isLoading | async }; as obs) {
    @if (obs.loading) {
      <div class="app-p-bar">
        <progress max="100" size="xs" tuiProgressBar></progress>
      </div>
    }
  }
  <router-outlet></router-outlet>
</tui-root>
